import React from 'react';
import { ArrowRightIcon, PhoneIcon } from 'lucide-react';
import { images } from '../data/images';
import { practice } from '../data/site';
import { HeroReviewCard } from './HeroReviewCard';
export function Hero() {
  return <section id="home" className="relative isolate flex min-h-[86vh] flex-col overflow-hidden bg-ink pt-[72px] lg:min-h-[92vh] lg:pt-[84px]" aria-labelledby="hero-title" data-id="element-309" data-mp="9llat1xpw6pm">
      <img src={images.hero} alt="Dr. Julio Lima DDS consulting with a patient at Lima Dental Group in Miami Lakes, Florida." className="absolute inset-0 h-full w-full object-cover object-[68%_center] lg:object-[58%_center]" data-id="element-310" data-mp="1285ztvqq06q0" />
      <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-r from-ink via-ink/75 to-transparent lg:via-ink/50" data-id="element-311" data-mp="nc858hwg3afw" />
      <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-t from-ink/90 via-ink/25 to-ink/50" data-id="element-312" data-mp="3d2bmnxfzddz8" />

      <div className="relative mx-auto flex w-full max-w-shell flex-1 flex-col justify-end px-5 pb-14 pt-20 sm:px-8 lg:px-12 lg:pb-20 lg:pt-32" data-id="element-313" data-mp="384s6ut3mwt56">
        <div className="max-w-[820px] animate-fadeUp" data-id="element-314" data-mp="3o6kgnlhm6i6p">
          <p className="eyebrow flex items-center gap-3 text-white/55" data-id="element-315" data-mp="3o59cvlo65afl">
            <span aria-hidden="true" className="h-px w-8 bg-accent" data-id="element-316" data-mp="39a35ovdc75ko" />
            Lima Dental Group · Miami Lakes, Florida
          </p>

          <h1 id="hero-title" className="font-display mt-9 text-[clamp(2.6rem,6.6vw,5.25rem)] leading-[1.03] text-white" data-id="element-317" data-mp="30i15my76jrax">
            35 years caring for
            <br data-id="element-318" data-mp="2qjv7mrohv5bc" />
            the smiles of
            <br data-id="element-319" data-mp="2qkwiav1llpsj" />
            <span className="font-display-em" data-id="element-320" data-mp="2qleq8oxmhsga">our neighbors.</span>
          </h1>

          <div className="mt-8 border-l-2 border-accent pl-5" data-id="element-321" data-mp="2vjzowjx8842m">
            <p className="eyebrow text-accent" data-id="element-322" data-mp="2hjf79r31seap">Since {practice.since}</p>
            <p className="mt-2.5 max-w-[46ch] text-[clamp(1.05rem,1.9vw,1.35rem)] font-medium leading-[1.5] text-white" data-id="element-323" data-mp="2hl9qn0yo7yco">
              A family-owned, independent practice serving Miami Lakes since {practice.since}.
            </p>
          </div>

          <p className="mt-7 max-w-[560px] text-[17px] leading-[1.8] text-white/75" data-id="element-324" data-mp="nb1jf112jluu">
            At Lima Dental Group we provide honest, personal dental care without pressure in
            Miami Lakes. Here you are not a number. You are part of our community.
          </p>

          <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-325" data-mp="1b0nk5sx3a94y">
            <a href={practice.bookingUrl} target="_blank" rel="noreferrer" className="group flex min-h-[54px] items-center justify-center gap-2.5 rounded-[10px] bg-white px-7 text-[15px] font-medium text-ink transition-all duration-300 hover:shadow-[0_0_0_3px_rgba(255,255,255,0.15)]" data-id="element-326" data-mp="1ayjh1d70le5q">
              Book an appointment
              <span className="hover-arrow" data-id="element-327" data-mp="3lquffqlsob64">
                <ArrowRightIcon aria-hidden="true" className="h-4 w-4" strokeWidth={1.75} data-id="element-328" data-mp="3hr3rrvrkeb5t" />
              </span>
            </a>
            <a href={practice.phoneHref} className="flex min-h-[54px] items-center justify-center gap-2.5 rounded-[10px] border border-white/25 px-7 text-[15px] font-medium text-white transition-colors hover:border-white/60" data-id="element-329" data-mp="1xavxukzeea7s">
              <PhoneIcon aria-hidden="true" className="h-4 w-4" strokeWidth={1.75} data-id="element-330" data-mp="2b0zf0xjf7dqd" />
              Call now
            </a>
          </div>

          <p className="mt-9 text-[15px] leading-relaxed text-white/70" data-id="element-331" data-mp="2fzj1r05u8tjs">
            Walk-ins welcome · New patients welcome · Care in English and Spanish
          </p>
        </div>

        <div className="mt-12 border-t border-white/10 pt-8 lg:mt-14" data-id="element-332" data-mp="2p1s9xjdmwau0">
          <HeroReviewCard data-id="element-333" data-mp="2u03ilqs70fan" />
        </div>
      </div>
    </section>;
}